import React from 'react';
import Grid from '@material-ui/core/Grid';

const GridItem = (props) => <Grid item={true} {...props}>{props.children}</Grid>;

export default GridItem;
